import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default function MProjectCard({
	title,
	img,
	href,
}) {
	return (
		<Link to={href} href={href}>
			<figure className="m-card-project">
				<img src={img} alt="" />
				<figcaption className="m-card-overlay">
					<p className="title">{title}</p>
				</figcaption>
			</figure>
		</Link>
	);
}

MProjectCard.propTypes = {
	title: PropTypes.string,
	img: PropTypes.string,
	href: PropTypes.string,
};

MProjectCard.defaultProps = {
	title: '',
	img: '',
	href: '',
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.project-card.js